//{% raw %}
import React, {useRef, useState} from 'react';
import Dragger from "antd/es/upload/Dragger";
import {InboxOutlined} from "@ant-design/icons";
import {Alert, Avatar, Button, Card, Layout, message, Space, Spin, Tag} from "antd";
import axios from "axios";

function App(props) {
    const [fileList, setFileList] = useState([])

    let currentIndex = 0;

    const checkButton = useRef();

    const documentValidation = () => {
        if (currentIndex < fileList.length) {
            const file = fileList[currentIndex];
            if (file.name.includes(".pdf")) {

                const formData = new FormData();
                formData.append('file', file.originFileObj); // 将文件对象添加到 FormData 对象中

                axios({
                    // url: "http://localhost:7071/verification/checkPdf",
                    url: "http://121.4.55.156:7071/verification/checkPdf",
                    method: "post",
                    data: formData
                }).then((res => {
                    setFileList(fileList.map((item) => {
                        if (item.uid === file.uid) {
                            item.status = "success";
                            item.result = res.data.data;
                        }
                        return item;
                    }))
                })).catch((e)=>{
                    setFileList(fileList.map((item) => {
                        if (item.uid === file.uid) {
                            item.status = "error";
                        }
                        return item;
                    }))
                }).finally(() => {
                    currentIndex++;
                    documentValidation();
                })
            } else if (file.name.includes(".dwg")) {
                axios({
                    url: "/api/File_General/File_GetDWGSignInfo_FormData",
                    method: "post",
                    headers: {
                        'Content-Type': 'multipart/form-data', // 设置请求头为 multipart/form-data
                    },
                    data: {
                        appId: "2850363718",
                        password: "90d68a4969a91dc1a5a1822a9a1e11b369ad291b3fe7e7f1c094edee61e35879",
                        file: file.originFileObj,
                        verify: "true"
                    }
                }).then(res => {
                    setFileList(fileList.map((item) => {
                        if (item.uid === file.uid) {
                            item.status = "success";

                            if (res.data === undefined || res.data.data === undefined || res.data.data.array === undefined || res.data.data.array.length === 0) {
                                item.result = [];
                            } else {
                                item.result = res.data.data.array[0].Recordarray.map(item => {
                                    return {
                                        integrity: item.verify,
                                        sigName: item.Name,
                                        sigDate:item.Referencearray[0].SignTime
                                    }
                                });
                            }
                        }
                        return item;
                    }))
                }).finally(() => {
                    currentIndex++;
                    documentValidation();
                })

            }
        } else {
            console.log(currentIndex, fileList.length)
            checkButton.current.removeAttribute("disabled");
            checkButton.current.innerText = "开始校验";
        }
    }

    return (
        <div style={{height: "100vh"}}>
            {fileList.length !== 0 ? (
                <Layout style={{display: "flex", height: "100%"}}>
                    <Layout.Header style={{
                        backgroundColor: "transparent",
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center"
                    }}>
                        <Space>
                            <Button size={"small"} type={"default"} ref={checkButton} onClick={() => {
                                currentIndex = 0;
                                // 禁用校验按钮
                                checkButton.current.setAttribute("disabled", "disabled");
                                checkButton.current.innerText = "校验中...";
                                setFileList(fileList.map((item) => {
                                    item.status = "loading";
                                    return item;
                                }))
                                documentValidation()
                            }}>开始校验</Button>
                            <Button size={"small"} type={"default"} onClick={() => {
                                setFileList([])
                            }}>重新上传</Button>
                        </Space>
                    </Layout.Header>
                    <Layout.Content style={{flex: "1"}}>
                        {fileList.map((file) => {
                            return (
                                <Card key={file.uid} style={{margin: "10px 0px"}}
                                      title={file.name}
                                      extra={file.name.includes(".pdf") ?
                                          <Avatar shape="square" src={`/image/PDF.png`}/> :
                                          <Avatar shape="square" src={`/image/dwg.png`}/>}>
                                    {file.status === "waiting" && (
                                        <Alert message="请点击右上角开始校验按钮" type="info" showIcon/>)}
                                    {file.status === "loading" && (
                                        <div><Tag color="processing">正在验证...</Tag><Spin/></div>)}
                                    {file.status === "success" && (<div>
                                        {file.result.length === 0 && (
                                            <Alert message="文件中无印章" type="warning" showIcon/>)}
                                        {file.result.map((item) => {
                                            return (
                                                <div>
                                                    <Alert message={item.sigName}
                                                           description={(item.integrity ? "验证成功" : "验证失败")+"   ---签章时间："+item.sigDate}
                                                           type={item.integrity ? 'success' : 'error'} showIcon/>
                                                </div>
                                            )
                                        })}
                                    </div>)}
                                    {file.status === "error" && (
                                        <Alert message="该签名无法验证，文档中签名证书区域存在错误" type="error" showIcon/>
                                    )}
                                </Card>
                            )
                        })}
                    </Layout.Content>
                </Layout>
            ) : (
                <Dragger
                    name={"file"}
                    multiple={true}
                    onChange={(info) => {
                        if (!info.file.name.includes(".pdf") && !info.file.name.includes(".dwg")) {
                            message.warning("请上传pdf或dwg文件进行验证," + info.file.name + "不支持")
                        }
                        setFileList(info.fileList.filter((file) => {
                            return file.name.includes(".pdf") || file.name.includes(".dwg")
                        }).map((file) => {
                            file.status = "waiting";
                            return file;
                        }))
                    }}
                    beforeUpload={(file) => {
                        return false;
                    }}
                    onDrop={(e) => {
                        console.log("onDrop", e)
                    }}
                    fileList={fileList}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined/>
                    </p>
                    <p className="ant-upload-text">点击或拖动文件到此区域进行验证。</p>
                    <p className="ant-upload-hint">
                        请上传pdf或dwg文件进行验证，支持单个或批量上传。
                    </p>
                </Dragger>
            )}
        </div>
    );
}

export default App;
//{% endraw %}
